'use strict';

var _regeneratorRuntime = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var addAll = require('./add-all');

var last = require('it-last');

var configure = require('./lib/configure');
/**
 * @param {import("./lib/core").ClientOptions} options
 */


module.exports = function (options) {
  var all = addAll(options);
  return configure(function () {
    /**
     * @type {import('.').Implements<typeof import('ipfs-core/src/components/add')>}
     */
    function add(_x) {
      return _add.apply(this, arguments);
    }

    function _add() {
      _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var options,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                _context.next = 3;
                return last(all(input, options));

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _add.apply(this, arguments);
    }

    return add;
  })(options);
};